// User ID Manager - Generates and manages unique user IDs
// Each visitor gets a unique UUID stored in localStorage

const USER_ID_KEY = 'allergen_app_user_id';

// Generate a UUID v4
const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

// Get or create user ID
export const getUserId = () => {
  let userId = localStorage.getItem(USER_ID_KEY);
  
  if (!userId) {
    userId = generateUUID();
    localStorage.setItem(USER_ID_KEY, userId);
    console.log('[UserIdManager] Created new user ID:', userId);
  }
  
  return userId;
};

// Check if user is new (just created their ID)
export const isNewUser = () => {
  return !localStorage.getItem(USER_ID_KEY);
};

// Clear user ID (for testing/reset purposes)
export const clearUserId = () => {
  localStorage.removeItem(USER_ID_KEY);
};

export default getUserId;
